<template>
  <div class="d-flex">
    <template v-if="image">
      <img :src="image"
           alt="Toolbar Icon"
           :style="{ width: small ? '22px' : '30px' }" />
    </template>
    <template v-else>
      <v-icon dark
              :size="small ? '22px' : '28px'">{{ icon }}</v-icon>
    </template>
    <h3 class="white--text font-weight-medium ml-2 text-capitalize"
        :style="{ fontSize: small ? '18px' : '24px' }"
        @click="increaseManualCharge()">{{ name }}</h3>
  </div>
</template>

<script>
export default {
  computed: {
    isManualChargeShown () {
      return this.$store.state.apps.isManualChargeShown
    }
  },
  data () {
    return {
      unlockedManualCharge: 0
    }
  },
  methods: {
    increaseManualCharge () {
      this.unlockedManualCharge++
      if (this.unlockedManualCharge % 3 === 0 && this.$route.name === 'Superuser Home') {
        this.$store.commit('SET_TOOLBAR_MANUAL_CHARGE_STATUS', !this.isManualChargeShown)
      }
    }
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    '$route' () {
      this.unlockedManualCharge = 0
      this.$store.commit('SET_TOOLBAR_MANUAL_CHARGE_STATUS', false)
    }
  }
}
</script>
